import Vue from "vue";
import {
  Button,
  Message,
  Container,
  Header,
  Main,
  Footer,
  Row,
  Collapse,
  CollapseItem,
  Col,
  Carousel,
  CarouselItem,
  Image,
  Icon,
  Input,
  Select,
  Option,
  Slider,
  Form,
  FormItem,
  Pagination,
  Empty,
  Loading,
  Breadcrumb,
  BreadcrumbItem,
  Dialog,
  Divider,
  Checkbox,
  CheckboxGroup,
  MessageBox,
  Tooltip,
  backtop,
} from "element-ui";
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.prototype.$ELEMENT = { size: "small" };
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(Loading.directive);
Vue.use(Button);
Vue.use(Container);
Vue.use(Header);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Col);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Slider);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dialog);
Vue.use(Divider);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tooltip);
Vue.use(backtop);

Vue.component(CollapseTransition.name, CollapseTransition);
